const trackGoal = (id, data = null) => {
  if("_paq" in window) {

    if(typeof id === 'undefined' || id === null) {
      console.log('No goal ID specified for trackGoal')
      return
    }

    _paq.push(['trackGoal', id, data])

  }
}

export {
  trackGoal
}


// WEBPACK FOOTER //
// ./source/js/components/trackGoal.js